const storageKey = (scope: string) => `cruxtify.filters.${scope}`;

export function readStickyFilterState(
  scope: string
): Record<string, string> | null {
  const key = storageKey(scope);

  try {
    const value = localStorage.getItem(key);
    if (value === null) return null;

    const parsed = JSON.parse(value);
    if (
      parsed === null ||
      typeof parsed !== "object" ||
      Array.isArray(parsed)
    ) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed as Record<string, string>;
  } catch {
    try {
      localStorage.removeItem(key);
    } catch {
      // Storage may remain unavailable, so cleanup is best-effort.
    }

    return null;
  }
}

export function writeStickyFilterState(
  scope: string,
  state: Record<string, string>
): void {
  try {
    if (Object.keys(state).length === 0) {
      localStorage.removeItem(storageKey(scope));
      return;
    }

    localStorage.setItem(storageKey(scope), JSON.stringify(state));
  } catch {
    // Sticky filters are optional and must never break collection pages.
  }
}

export function clearStickyFilterState(scope: string): void {
  try {
    localStorage.removeItem(storageKey(scope));
  } catch {
    // Sticky filters are optional and must never break collection pages.
  }
}
